import { z } from 'zod';
import { BaseEventSchema } from '../Base';

export enum FormIdentifiersForEvents {
  CREATE_ADDRESS = 'create_address',
  EDIT_ADDRESS = 'edit_address',
  NEW_USER_DATA = 'new_user_data',
  NEW_USER_SOURCE = 'new_user_source',
}

export enum InputIdentifiersForEvents {
  // CREATE_ADDRESS || EDIT_ADDRESS form
  ADDRESS_STREET_NAME = 'street_name',
  ADDRESS_STREET_NUMBER = 'street_number',
  ADDRESS_HOUSE_NUMBER = 'house_number',
  ADDRESS_INSTRUCTIONS = 'address_instructions',
  // NEW_USER_DATA Form
  NEW_USER_NAME = 'new_user_name',
  NEW_USER_LAST_NAME = 'new_user_last_name',
  NEW_USER_RUT = 'new_user_rut',
  NEW_USER_PHONE = 'new_user_phone',
  NEW_USER_EMAIL = 'new_user_email',
  NEW_USER_BIRTHDAY_DAY = 'new_user_birthday_day',
  NEW_USER_BIRTHDAY_MONTH = 'new_user_birthday_month',
  NEW_USER_BIRTHDAY_YEAR = 'new_user_birthday_year',
  // NEW_USER_SOURCE Form
  NEW_USER_SOURCE = 'new_user_source',
  NEW_USER_REFERRER_CODE = 'new_user_referrer_code',
  NEW_USER_ACCEPT_TERMS = 'new_user_accept_terms',
}

export const ClickNextEventSchema = BaseEventSchema.extend({
  location: z.enum([
    'login',
    'last_whim',
    'checkout_delivery_address',
    'checkout_delivery_date',
    'signup_user_info',
    'signup_source_info',
  ]),
});

export const CreateAddressEventSchema = BaseEventSchema.extend({
  street: z.string(),
  street_number: z.string(),
  commune: z.string(),
  apartment: z.string(),
  instructions: z.string(),
});

export const SelectAddressEventSchema = BaseEventSchema.extend({
  commune: z.string().nullable(),
  zone: z.enum(['ZONE_A', 'ZONE_B', 'ZONE_C', 'NO_ZONE']).nullable(),
  delivery_type: z.enum(['PICK_UP', 'DELIVERY']),
});

export const SelectDeliveryDateEventSchema = BaseEventSchema.extend({
  express: z.boolean(),
  deliveries: z.number(),
});

export const SelectPaymentMethodEventSchema = BaseEventSchema.extend({
  payment_method_type: z.string(),
  card_type: z.string().nullable(),
  has_meki_credits: z.boolean().nullable(),
  has_insurance: z.boolean().nullable(),
  prescriptions_required: z.boolean(),
  prescriptions_needed: z.boolean(),
  highest_prescription_type: z.string(),
});

export const ClickNewAddressEventSchema = BaseEventSchema.extend({
  address_quantity: z.number(),
});

export const FormInputEventSchema = BaseEventSchema.extend({
  value: z.any().nullable(),
  input_name: z.nativeEnum(InputIdentifiersForEvents),
  form_name: z.nativeEnum(FormIdentifiersForEvents),
});

export const FormSubmitEventSchema = BaseEventSchema.extend({
  form_name: z.nativeEnum(FormIdentifiersForEvents),
});

export enum OtherInteractionEventTypes {
  CreateAddress = 'interaction.create_address',
  SelectAddress = 'interaction.select_address',
  SelectDeliveryDate = 'interaction.select_delivery_date',
  SelectPaymentMethod = 'interaction.select_payment_method',
  ClickNext = 'interaction.click_next',
  ClickNewAddress = 'interaction.click_new_address',
  AddressUseCurrentLocation = 'interaction.address_use_current_location',
  FormInput = 'interaction.form.input',
  FormSubmit = 'interaction.form.submit',
}

export const OtherInteractionEventTrackingSchemas = {
  [OtherInteractionEventTypes.CreateAddress]: CreateAddressEventSchema,
  [OtherInteractionEventTypes.SelectAddress]: SelectAddressEventSchema,
  [OtherInteractionEventTypes.SelectDeliveryDate]:
    SelectDeliveryDateEventSchema,
  [OtherInteractionEventTypes.SelectPaymentMethod]:
    SelectPaymentMethodEventSchema,
  [OtherInteractionEventTypes.ClickNext]: ClickNextEventSchema,
  [OtherInteractionEventTypes.ClickNewAddress]: ClickNewAddressEventSchema,
  [OtherInteractionEventTypes.AddressUseCurrentLocation]: BaseEventSchema,
  [OtherInteractionEventTypes.FormInput]: FormInputEventSchema,
  [OtherInteractionEventTypes.FormSubmit]: FormSubmitEventSchema,
};
